import React, { useState, useEffect } from "react";
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  collection,
  getDocs,
} from "firebase/firestore";
import { FaInstagram, FaMapMarkerAlt } from "react-icons/fa";

import { CiPizza, CiBeerMugFull, CiFries } from "react-icons/ci";
import { GiSandwich } from "react-icons/gi";
import { PiChefHatBold } from "react-icons/pi";

import FooterPubblico from "../footer/FooterPubblico";

import ConfirmWorkMenuModal from "./ConfirmWorkMenuModal";


const Menu = ({ isProtected }) => {
  const [categorie, setCategorie] = useState([]);
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isCortesia, setIsCortesia] = useState(false);
  const [openAccordion, setOpenAccordion] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [pendingCortesiaState, setPendingCortesiaState] = useState(null);

  const db = getFirestore();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const startTime = Date.now();
      const options = { source: "server" };
      try {
        const docRef = doc(db, "settings", "work");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setIsCortesia(data.isCortesia || false);
        } else {
          await setDoc(docRef, { isCortesia: false });
        }

        const categorieSnapshot = await getDocs(
          collection(db, "categorie"),
          options
        );
        const menuSnapshot = await getDocs(collection(db, "menu"), options);

        setCategorie(
          categorieSnapshot.docs.map((doc) => ({
            id: doc.id,
            tipo: doc.data().tipo.trim(),
          }))
        );

        setMenu(
          menuSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            nome: doc.data().nome.trim(),
            ingredienti: doc.data().ingredienti.trim(),
            note: doc.data().note.trim(),
          }))
        );
      } catch (error) {
        console.error("Errore nel caricamento dei dati:", error);
        alert("Errore durante il caricamento dei dati. Riprova più tardi.");
      } finally {
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(0, 3000 - elapsed);
        setTimeout(() => setLoading(false), remaining);
      }
    };

    fetchData();
  }, [db]);

  const updateCortesia = async (newValue) => {
    try {
      const docRef = doc(db, "settings", "work");
      await setDoc(docRef, { isCortesia: newValue }, { merge: true });
      setIsCortesia(newValue);
    } catch (error) {
      console.error("Errore nell'aggiornamento del flag di cortesia:", error);
      alert("Errore durante l'aggiornamento del flag. Riprova.");
    }
  };

  const handleSwitchChange = (newValue) => {
    setPendingCortesiaState(newValue);
    setModalOpen(true);
  };

  const confirmChange = () => {
    updateCortesia(pendingCortesiaState);
    setModalOpen(false);
    setPendingCortesiaState(null);
  };

  const cancelChange = () => {
    setModalOpen(false);
    setPendingCortesiaState(null);
  };

  const getCategoryAccent = (tipo) => {
    if (tipo.includes("Rosse")) return { border: "#c0392b", bg: "#fff5f5", text: "#c0392b" };
    if (tipo.includes("Bianche")) return { border: "#6b7280", bg: "#f9fafb", text: "#374151" };
    if (tipo.includes("Dolci")) return { border: "#eab308", bg: "#fefce8", text: "#713f12" };
    if (tipo.includes("Bevande")) return { border: "#0ea5e9", bg: "#f0f9ff", text: "#0369a1" };
    if (tipo.includes("Fritti")) return { border: "#d97706", bg: "#fffbeb", text: "#92400e" };
    if (tipo.includes("Pane")) return { border: "#16a34a", bg: "#f0fdf4", text: "#14532d" };
    return { border: "#7c3aed", bg: "#faf5ff", text: "#5b21b6" };
  };

  if (loading) {
    return (
      <div
        className="fixed inset-0 flex flex-col items-center justify-center z-50"
        style={{ background: "#fafaf8" }}
        translate="no"
      >
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital@1&display=swap');

          .blob { position:absolute; border-radius:50%; filter:blur(40px); opacity:0; }
          .blob1 { width:260px; height:180px; background:rgba(192,57,43,0.18); top:20%; left:15%;
            animation:blobMove1 3s ease-in-out infinite; }
          .blob2 { width:200px; height:200px; background:rgba(200,132,58,0.15); top:30%; right:10%;
            animation:blobMove2 3s ease-in-out infinite; }
          .blob3 { width:180px; height:140px; background:rgba(45,106,45,0.12); bottom:15%; left:30%;
            animation:blobMove3 3s ease-in-out infinite; }

          @keyframes blobMove1 {
            0%,100%{opacity:0;transform:translate(0,0) scale(1);}
            40%{opacity:1;} 55%{opacity:1;transform:translate(10px,-15px) scale(1.08);} 75%{opacity:0.3;}
          }
          @keyframes blobMove2 {
            0%,100%{opacity:0;transform:translate(0,0) scale(1);}
            45%{opacity:0.8;} 58%{opacity:0.8;transform:translate(-8px,10px) scale(1.06);} 78%{opacity:0;}
          }
          @keyframes blobMove3 {
            0%,100%{opacity:0;transform:translate(0,0) scale(1);}
            42%{opacity:0.7;} 60%{opacity:0.7;transform:translate(12px,-8px) scale(1.1);} 80%{opacity:0;}
          }

          .tray-svg { position:absolute; inset:0; animation:trayPop 3s ease-in-out infinite; transform-origin:center; }
          @keyframes trayPop {
            0%{transform:scale(0.93);} 45%{transform:scale(1.0);}
            58%{transform:scale(1.07);} 72%{transform:scale(1.0);} 100%{transform:scale(0.93);}
          }

          .pp { position:absolute; border-radius:50%; }
          .p1{width:28px;height:28px;border:2px solid rgba(192,57,43,0.5);background:transparent;top:10px;left:50px;animation:floatP1 3s ease-in-out infinite;}
          .p2{width:18px;height:18px;border:1.5px solid rgba(200,132,58,0.6);background:transparent;top:8px;left:110px;animation:floatP2 3s ease-in-out infinite;}
          .p3{width:12px;height:12px;background:rgba(192,57,43,0.7);top:30px;left:155px;animation:floatP3 3s ease-in-out infinite;}
          .p4{width:20px;height:20px;border:1.5px solid rgba(45,106,45,0.6);background:transparent;top:75px;left:160px;animation:floatP4 3s ease-in-out infinite;}
          .p5{width:10px;height:10px;background:rgba(200,132,58,0.8);top:100px;left:120px;animation:floatP5 3s ease-in-out infinite;}
          .p6{width:22px;height:22px;border:2px solid rgba(192,57,43,0.4);background:transparent;top:105px;left:50px;animation:floatP6 3s ease-in-out infinite;}
          .p7{width:8px;height:8px;background:rgba(45,106,45,0.8);top:80px;left:8px;animation:floatP7 3s ease-in-out infinite;}
          .p8{width:16px;height:16px;border:1.5px solid rgba(200,132,58,0.5);background:transparent;top:20px;left:5px;animation:floatP8 3s ease-in-out infinite;}

          .ll{position:absolute;background:rgba(192,57,43,0.35);border-radius:2px;}
          .l1{width:2px;height:22px;top:5px;left:80px;transform:rotate(20deg);animation:floatP1 3s ease-in-out infinite;}
          .l2{width:2px;height:16px;top:95px;left:140px;transform:rotate(-15deg);animation:floatP3 3s ease-in-out infinite;}

          @keyframes floatP1{0%,30%{transform:translate(0,0) scale(0);opacity:0;}55%{transform:translate(-20px,-30px) scale(1);opacity:1;}100%{transform:translate(-30px,-46px) scale(0.4);opacity:0;}}
          @keyframes floatP2{0%,35%{transform:translate(0,0) scale(0);opacity:0;}58%{transform:translate(6px,-34px) scale(1);opacity:1;}100%{transform:translate(10px,-52px) scale(0.3);opacity:0;}}
          @keyframes floatP3{0%,32%{transform:translate(0,0) scale(0);opacity:0;}56%{transform:translate(28px,-24px) scale(1);opacity:1;}100%{transform:translate(44px,-38px) scale(0.4);opacity:0;}}
          @keyframes floatP4{0%,38%{transform:translate(0,0) scale(0);opacity:0;}60%{transform:translate(32px,4px) scale(1);opacity:1;}100%{transform:translate(50px,8px) scale(0.3);opacity:0;}}
          @keyframes floatP5{0%,34%{transform:translate(0,0) scale(0);opacity:0;}57%{transform:translate(24px,28px) scale(1);opacity:1;}100%{transform:translate(36px,44px) scale(0.4);opacity:0;}}
          @keyframes floatP6{0%,36%{transform:translate(0,0) scale(0);opacity:0;}59%{transform:translate(0px,32px) scale(1);opacity:1;}100%{transform:translate(0px,50px) scale(0.3);opacity:0;}}
          @keyframes floatP7{0%,33%{transform:translate(0,0) scale(0);opacity:0;}56%{transform:translate(-26px,26px) scale(1);opacity:1;}100%{transform:translate(-40px,42px) scale(0.4);opacity:0;}}
          @keyframes floatP8{0%,37%{transform:translate(0,0) scale(0);opacity:0;}60%{transform:translate(-32px,2px) scale(1);opacity:1;}100%{transform:translate(-50px,-2px) scale(0.3);opacity:0;}}

          .steam-loader{position:absolute;top:-12px;left:50%;transform:translateX(-50%);display:flex;gap:20px;}
          .steam-loader span{width:2px;height:14px;border-radius:2px;background:rgba(192,57,43,0.25);display:block;animation:steamUp 2s ease-in-out infinite;}
          .steam-loader span:nth-child(2){animation-delay:0.4s;height:20px;}
          .steam-loader span:nth-child(3){animation-delay:0.8s;}
          @keyframes steamUp{0%{opacity:0;transform:translateY(0);}50%{opacity:1;transform:translateY(-12px) scaleX(1.4);}100%{opacity:0;transform:translateY(-24px);}}

          .loader-sub-text{font-family:'Playfair Display',Georgia,serif;font-style:italic;font-size:14px;color:#9ca3af;letter-spacing:0.04em;animation:fadePulse 3s ease-in-out infinite;}
          @keyframes fadePulse{0%,100%{opacity:0.3;}50%{opacity:1;}}
          .bar-wrap-loader{width:56px;height:1px;background:#e5e7eb;border-radius:1px;overflow:hidden;}
          .bar-loader{height:100%;width:0%;background:#c0392b;animation:barGrow 3s ease-in-out infinite;}
          @keyframes barGrow{0%{width:0%;}70%{width:100%;}100%{width:100%;opacity:0;}}
        `}</style>

        <div className="blob blob1" />
        <div className="blob blob2" />
        <div className="blob blob3" />

        <div style={{ position: "relative", width: 180, height: 130, marginBottom: 32 }}>
          <div className="steam-loader">
            <span /><span /><span />
          </div>
          <div className="pp p1" /><div className="pp p2" /><div className="pp p3" />
          <div className="pp p4" /><div className="pp p5" /><div className="pp p6" />
          <div className="pp p7" /><div className="pp p8" />
          <div className="ll l1" /><div className="ll l2" />

          <svg className="tray-svg" viewBox="0 0 180 130" xmlns="http://www.w3.org/2000/svg">
            <rect x="5" y="14" width="170" height="102" rx="7" fill="#3d2510"/>
            <rect x="12" y="20" width="156" height="90" rx="5" fill="#c8843a"/>
            <rect x="12" y="20" width="156" height="90" rx="5" fill="none" stroke="#e8a96a" strokeWidth="8"/>
            <rect x="22" y="29" width="136" height="72" rx="3" fill="#c0392b"/>
            <ellipse cx="55" cy="52" rx="17" ry="11" fill="#f5ede0" opacity="0.93"/>
            <ellipse cx="98" cy="62" rx="15" ry="11" fill="#f5ede0" opacity="0.88"/>
            <ellipse cx="138" cy="46" rx="13" ry="10" fill="#f5ede0" opacity="0.9"/>
            <ellipse cx="76" cy="78" rx="12" ry="9" fill="#f5ede0" opacity="0.85"/>
            <ellipse cx="68" cy="63" rx="7" ry="3.5" fill="#2d6a2d" transform="rotate(-20 68 63)"/>
            <ellipse cx="118" cy="54" rx="6" ry="3" fill="#2d6a2d" transform="rotate(12 118 54)"/>
            <circle cx="40" cy="72" r="5" fill="#222"/><circle cx="40" cy="72" r="2" fill="#555"/>
            <circle cx="110" cy="38" r="4.5" fill="#222"/><circle cx="110" cy="38" r="2" fill="#555"/>
            <circle cx="148" cy="74" r="4" fill="#222"/><circle cx="148" cy="74" r="2" fill="#555"/>
          </svg>
        </div>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}>
          <div className="bar-wrap-loader"><div className="bar-loader" /></div>
          <p className="loader-sub-text">sto preparando il menu</p>
        </div>
      </div>
    );
  }

  if (!isProtected && isCortesia) {
    return (
      <div
        className="flex flex-col items-center justify-center bg-gray-50 h-screen"
        translate="no"
      >
        <img
          src="/img/logoTrasparente.png"
          alt="Nuovo Forno dal 1966"
          className="w-40 h-auto mb-6"
        />
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Nuovo Forno dal 1966
        </h1>
        <h2 className="text-xl font-semibold text-gray-700 mb-4">
          Aggiornamento in corso
        </h2>
        <p className="text-base text-gray-600 text-center">
          Stiamo aggiornando il menu per offrirti un'esperienza migliore. <br />
          Torna a trovarci presto!
        </p>
      </div>
    );
  }

  const sortedCategorie = [...categorie].sort((a, b) => {
    const order = {
      "Le Nostre Pizze Rosse": 1,
      "Le Nostre Pizze Bianche": 2,
      "Le Nostre Pizze Dolci": 3,
      "Fritti": 4,
      "Bevande": 5,
    };
    return (order[a.tipo] || 99) - (order[b.tipo] || 99);
  });

  return (
    <div className="flex flex-col min-h-screen bg-gray-50" translate="no">
      <div className="w-full mx-auto px-3 sm:px-6 py-6 sm:py-10 flex-grow max-w-5xl">

        {/* Header */}
        <div className="text-center mb-8 sm:mb-10">
          <p className="text-xs tracking-widest text-gray-400 uppercase mb-1">dal 1966</p>
          <h1
            className="font-elegant text-4xl sm:text-5xl text-gray-900"
            style={{ letterSpacing: "-0.01em" }}
          >
            {isProtected ? "Menu" : "Menu"}
          </h1>
          <div className="mx-auto mt-3 h-px w-16 bg-red-400 rounded-full" />
        </div>

        {/* Switch cortesia */}
        {isProtected && (
          <div className="flex items-center gap-2 justify-end mb-6">
            <label
              htmlFor="cortesiaSwitch"
              className="text-sm font-medium text-gray-500"
            >
              Pagina di cortesia
            </label>
            <input
              id="cortesiaSwitch"
              type="checkbox"
              className="w-5 h-5 cursor-pointer accent-red-500"
              checked={isCortesia}
              onChange={() => handleSwitchChange(!isCortesia)}
            />
          </div>
        )}

        {/* Accordion categorie */}
        <div className="space-y-3">
          {sortedCategorie.map((cat) => {
            const accent = getCategoryAccent(cat.tipo);
            const isOpen = openAccordion === cat.tipo;

            // ── Filtra solo le voci visibili (visibile !== false) ──
            const vociVisibili = menu.filter(
              (item) => item.categoria === cat.tipo && item.visibile !== false
            );

            return (
              <div
                key={cat.id}
                className="rounded-xl overflow-hidden shadow-sm border border-gray-200 bg-white"
                translate="no"
              >
                {/* Header accordion */}
                <button
                  className="w-full px-5 py-4 flex justify-between items-center transition-colors duration-200"
                  style={{
                    borderLeft: `4px solid ${accent.border}`,
                    background: isOpen ? accent.bg : "white",
                  }}
                  onClick={() =>
                    setOpenAccordion(isOpen ? null : cat.tipo)
                  }
                >
                  <span
                    className="font-semibold text-base sm:text-lg"
                    style={{ color: isOpen ? accent.text : "#1f2937" }}
                  >
                    {cat.tipo}
                  </span>
                  <span className="flex items-center gap-2 text-gray-400 text-lg">
                    {cat.tipo.includes("Bianche") && <CiPizza />}
                    {cat.tipo.includes("Rosse") && <CiPizza />}
                    {cat.tipo.includes("Bevande") && <CiBeerMugFull />}
                    {cat.tipo.includes("Fritti") && <CiFries />}
                    {cat.tipo.includes("Pane") && <GiSandwich />}
                    {!(
                      cat.tipo.includes("Bianche") ||
                      cat.tipo.includes("Rosse") ||
                      cat.tipo.includes("Bevande") ||
                      cat.tipo.includes("Fritti") ||
                      cat.tipo.includes("Pane")
                    ) && <PiChefHatBold />}
                    <span
                      className="text-sm font-bold w-5 h-5 flex items-center justify-center rounded-full transition-all duration-200"
                      style={{
                        background: isOpen ? accent.border : "#f3f4f6",
                        color: isOpen ? "white" : "#6b7280",
                      }}
                    >
                      {isOpen ? "−" : "+"}
                    </span>
                  </span>
                </button>

                {/* Contenuto accordion */}
                {isOpen && (
                  <div className="p-3 sm:p-5 bg-gray-50 border-t border-gray-100">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                      {vociVisibili.map((piatto) => (
                          <div
                            key={piatto.id}
                            className="bg-white rounded-lg p-4 border border-gray-200 flex flex-col gap-2 transition-shadow duration-200 hover:shadow-md"
                            style={{ borderLeft: `3px solid ${accent.border}` }}
                            translate="no"
                          >
                            {/* Nome + Prezzo */}
                            <div className="flex justify-between items-start gap-2">
                              <h2 className="font-elegant text-lg sm:text-xl text-gray-900 leading-snug flex-grow">
                                {piatto.nome}
                              </h2>
                              <span
                                className="text-sm font-bold flex-shrink-0"
                                style={{ color: "#111111" }}
                              >
                                {piatto.prezzo}€
                              </span>
                            </div>

                            {/* Ingredienti */}
                            {piatto.ingredienti?.trim() && (
                              <p className="text-gray-600 text-sm leading-relaxed">
                                <span className="font-medium" style={{ color: accent.border }}>
                                  Ingredienti:{" "}
                                </span>
                                {piatto.ingredienti}
                              </p>
                            )}

                            {/* Note */}
                            {piatto.note?.trim() && (
                              <div>
                                <span
                                  className="inline-block text-xs font-medium px-2 py-0.5 rounded-full"
                                  style={{
                                    background: "#f3f4f6",
                                    color: "#374151",
                                    border: "1px solid #d1d5db",
                                  }}
                                >
                                  {piatto.note}
                                </span>
                              </div>
                            )}

                            {/* Allergeni */}
                            {piatto.allergeni?.filter(
                              (allergene) => allergene.trim() !== ""
                            ).length > 0 && (
                              <div className="pt-1 border-t border-gray-100">
                                <div className="flex flex-wrap items-center gap-1.5">
                                  <span
                                    className="text-xs font-medium px-2 py-0.5 rounded-full"
                                    style={{ background: "#fff5f5", color: "#c0392b", border: "1px solid #fca5a5" }}
                                  >
                                    ⚠ allergeni
                                  </span>
                                  {piatto.allergeni
                                    .filter((a) => a.trim() !== "")
                                    .map((a, i) => (
                                      <span
                                        key={i}
                                        className="text-xs px-2 py-0.5 rounded-full"
                                        style={{
                                          background: "#f3f4f6",
                                          color: "#374151",
                                          border: "1px solid #d1d5db",
                                        }}
                                      >
                                        {a}
                                      </span>
                                    ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                    </div>

                    {vociVisibili.length === 0 && (
                      <p className="text-gray-400 italic text-center py-4 text-sm">
                        Non disponibile.
                      </p>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Disclaimer allergeni */}
        <p className="text-center text-xs text-gray-400 mt-8 px-4 leading-relaxed">
          Le informazioni sugli allergeni sono indicative. Per allergie o intolleranze gravi,
          ti invitiamo a informare il personale prima di ordinare.
        </p>
      </div>

      <ConfirmWorkMenuModal
        isOpen={isModalOpen}
        onConfirm={confirmChange}
        onCancel={cancelChange}
        message="Sei sicuro di voler modificare la pagina di cortesia?"
      />

      {!isProtected && <FooterPubblico />}
    </div>
  );
};

export default Menu;